import React, { useEffect } from "react";
import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";
import ApplicationTypeComponentLegacy from "../../../components/applicationComponents/legacy/applicationType/ApplicationTypeComponentLegacy";

export default function ApplicationTypePageLegacy() {
  const { setHeaderText } = useApplicationContext();

  useEffect(() => {
    setHeaderText({
      value: "Edit Type of Application",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);

  return <ApplicationTypeComponentLegacy disabled={false} />;
}
